import React from "react";
import logo from "../assets/colophon.svg";
import styled from "styled-components";
import { Link } from "gatsby";
import { MAX_WIDTH_MOBILE_NAV } from "./Navigation";

const Wrapper = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 3px solid ${(props) => props.theme.envy};
  padding: 26px 0 37px;
  margin: 0 50px;
  font-size: 20px;
  line-height: 1.7;

  @media (max-width: 960px) {
    display: block;
    font-size: 18px;
  }

  @media (max-width: ${MAX_WIDTH_MOBILE_NAV}px) {
    margin: 0 32px;
  }
`;

const Colophon = styled.div`
  display: flex;
  align-items: center;
  img {
    height: 33px;
    margin-right: 23px;
  }
`;

const FooterLink = styled.a`
  font-weight: bold;
  color: ${(props) => props.theme.confusion}!important;
  line-height: 1.3;
  border-bottom: 3px solid transparent;
  transform: translateY(2px);
  &:hover {
    border-color: ${(props) => props.theme.envy};
  }
`;

const FooterLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 20px;
  row-gap: 10px;

  @media (max-width: 960px) {
    margin-top: 20px;
  }
`;

export const Footer = () => {
  return (
    <Wrapper>
      <Colophon>
        <img src={logo} alt="Imbue logo" />
        <span>{new Date().getFullYear()} Imbue</span>
      </Colophon>
      <FooterLinks>
        <FooterLink as={Link} to="/legal/privacy">
          Privacy Policy
        </FooterLink>
        <FooterLink as={Link} to="/legal/terms">
          Terms of Use
        </FooterLink>
        <FooterLink as={Link} to="/blog">
          Blog
        </FooterLink>
        <FooterLink href="https://twitter.com/imbue_ai">Twitter</FooterLink>
      </FooterLinks>
    </Wrapper>
  );
};
